import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkout"
export default class extends Controller {
  static targets = ["step"]
  static values = { step: String }

  connect() {
    this.applyStep(this.resolvedStep)
  }

  stepValueChanged(value) {
    if (value) this.applyStep(value)
  }

  /**
   * Triggered when clicking "Continue"
   */
  next(event) {
    event.preventDefault()

    const current = this.currentStep
    const nextStep = this.getNextStep(current)

    if (nextStep) {
      this.stepValue = nextStep
      this.applyStep(nextStep)

      const el = this.stepTargets.find(el => el.dataset.checkoutStep === nextStep)
      el?.scrollIntoView({ behavior: "smooth" })
    }
  }

  /**
   * Show a specific step by name
   */
  applyStep(name) {
    const stepName = name || "contact"
    this.stepTargets.forEach(el => {
      const step = el.dataset.checkoutStep
      el.classList.toggle("hidden", step !== stepName)
    })
  }

  /**
   * Returns the name of the currently visible step
   */
  get currentStep() {
    const current = this.stepTargets.find(el => !el.classList.contains("hidden"))
    return current?.dataset.checkoutStep
  }

  /**
   * Step order for progression
   */
  getNextStep(current) {
    const order = ["contact", "shipping", "billing", "review"]
    const index = order.indexOf(current)
    return order[index + 1] || null
  }

  get resolvedStep() {
    if (this.hasStepValue && this.stepValue) return this.stepValue
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("step") || "contact"
  }
}
